export class StatusCodeError extends Error {
    response: Response;

    constructor(response: Response) {
        super();
        this.name = 'StatusCodeError';
        this.message = 'status code not 200';
        this.response = response;
    }
}
